// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { caseInsensitiveEnum } from '@/constants/case-insensitive-enum';
import { Theme } from '@mui/material';
import { z } from 'zod';

// Mirrors `enums.ChargeStatus` on the BE.
export const chargeStatusSchema = caseInsensitiveEnum([
  'PLANNED',
  'BILLABLE',
  'INVOICED',
  'CANCELLED',
]);

export type ChargeStatus = z.infer<typeof chargeStatusSchema>;

export const ChargeStatuses: ChargeStatus[] = [...chargeStatusSchema.options];

export const ChargeStatusLabelMap = (status: ChargeStatus) => {
  switch (status) {
    case 'PLANNED':
      return 'Planned';
    case 'BILLABLE':
      return 'Billable';
    case 'INVOICED':
      return 'Invoiced';
    case 'CANCELLED':
      return 'Cancelled';
  }
};

export const ChargeStatusColorMap = (status: ChargeStatus, theme: Theme) => {
  switch (status) {
    case 'PLANNED':
      return theme.palette.grey[300];
    case 'BILLABLE':
      return theme.palette.warning.main;
    case 'INVOICED':
      return theme.palette.success.main;
    case 'CANCELLED':
      return theme.palette.error.main;
  }
};
